"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ROTATE_SIZE = 32;
var ROTATE_GAP = 15;
var DEG_PER_RAD = 180 / Math.PI;
var DEFAULT_ROTATE_HANDLE_HEIGHT = ROTATE_SIZE / 2 + ROTATE_GAP;
var ROTATE_ICON_MARGIN = 8;
/**
 * @internal
 * The rotate drag and drop handler
 */
exports.Rotator = {
    onDragStart: function (_a) {
        var editInfo = _a.editInfo;
        return (__assign({}, editInfo));
    },
    onDragging: function (_a, e, base, deltaX, deltaY) {
        var editInfo = _a.editInfo, options = _a.options;
        var distance = editInfo.heightPx / 2 + DEFAULT_ROTATE_HANDLE_HEIGHT;
        var newX = distance * Math.sin(base.angleRad) + deltaX;
        var newY = distance * Math.cos(base.angleRad) - deltaY;
        var angleInRad = Math.atan2(newX, newY);
        if (!e.altKey) {
            var angleInDeg = angleInRad * DEG_PER_RAD;
            var adjustedAngleInDeg = Math.round(angleInDeg / options.minRotateDeg) * options.minRotateDeg;
            angleInRad = adjustedAngleInDeg / DEG_PER_RAD;
        }
        if (editInfo.angleRad != angleInRad) {
            editInfo.angleRad = angleInRad;
            return true;
        }
        else {
            return false;
        }
    },
};
/**
 * @internal
 * Move rotate handle. When image is very close to the border of editor, rotate handle may not be visible.
 * Fix it by reduce the distance from image to rotate handle
 */
function updateRotateHandlePosition(editInfo, distance, marginVertical, rotateCenter, rotateHandle) {
    if (rotateCenter && rotateHandle && distance) {
        var angleRad = editInfo.angleRad, heightPx = editInfo.heightPx;
        var cosAngle = Math.cos(angleRad);
        var adjustedDistance = cosAngle <= 0
            ? Number.MAX_SAFE_INTEGER
            : (distance[1] + heightPx / 2 + marginVertical) / cosAngle - heightPx / 2;
        var rotateGap = Math.max(Math.min(ROTATE_GAP, adjustedDistance), 0);
        var rotateTop = Math.max(Math.min(ROTATE_SIZE, adjustedDistance - rotateGap), 0);
        rotateCenter.style.top = -rotateGap + 'px';
        rotateCenter.style.height = rotateGap + 'px';
        rotateHandle.style.top = -rotateTop + 'px';
    }
}
exports.updateRotateHandlePosition = updateRotateHandlePosition;
/**
 * @internal
 * Get HTML for rotate elements, including the rotate handle with icon, and a line between the handle and the image
 */
function getRotateHTML(_a) {
    var borderColor = _a.borderColor, rotateHandleBackColor = _a.rotateHandleBackColor;
    var handleLeft = ROTATE_SIZE / 2;
    return [
        {
            tag: 'div',
            className: "r_rotateC" /* RotateCenter */,
            style: "position:absolute;left:50%;width:1px;background-color:" + borderColor,
            children: [
                {
                    tag: 'div',
                    className: "r_rotateH" /* RotateHandle */,
                    style: "position:absolute;background-color:" + rotateHandleBackColor + ";border:solid 1px " + borderColor + ";border-radius:50%;width:" + ROTATE_SIZE + "px;height:" + ROTATE_SIZE + "px;left:-" + handleLeft + "px;cursor:move",
                    children: [getRotateIconHTML(borderColor)],
                },
            ],
        },
    ];
}
exports.getRotateHTML = getRotateHTML;
function getRotateIconHTML(borderColor) {
    var _a;
    return {
        tag: 'svg',
        namespace: 'http://www.w3.org/2000/svg',
        style: "width:16px;height:16px;margin: " + ROTATE_ICON_MARGIN + "px " + ROTATE_ICON_MARGIN + "px",
        children: [
            {
                tag: 'path',
                namespace: 'http://www.w3.org/2000/svg',
                attributes: (_a = {
                        d: 'M 10.5,10.0 A 3.8,3.8 0 1 1 6.7,6.3',
                        transform: 'matrix(1.1 1.1 -1.1 1.1 11.6 -10.8)'
                    },
                    _a['fill-opacity'] = '0',
                    _a.stroke = borderColor,
                    _a),
            },
            {
                tag: 'path',
                namespace: 'http://www.w3.org/2000/svg',
                attributes: {
                    d: 'M12.0 3.648l.884-.884.53 2.298-2.298-.53z',
                    stroke: borderColor,
                },
            },
        ],
    };
}
//# sourceMappingURL=Rotator.js.map